module.exports = __webpack_public_path__ + "media/Video 115.f4dd2ebc.mp4";